<template>
  <v-checkbox :readonly="readonly" :label="prop.text" v-model="value" :color="prop.color">
  </v-checkbox>
</template>

<style scoped>

</style>

<script>
  import CheckInput from "./checkInput.ts";
  export default CheckInput;
</script>